import React from 'react';

import { Box, Typography } from '@mui/material';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import classes from './loadingSpinner.module.css';

import { ReactComponent as Spinner } from 'asset/img/spinner.svg';

const LoadingSpinner = ({ text = 'Loading', spinnerClassName = '' }) => {
    return (
        <Box className={classes.container}>
            <Spinner className={clsx(classes.spinner, spinnerClassName)} />
            {text && <Typography className={classes.text}>{text}</Typography>}
        </Box>
    );
};

LoadingSpinner.propTypes = {
    text: PropTypes.string,
    spinnerClassName: PropTypes.string,
};

export default LoadingSpinner;
